import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

interface QuoteIconProps extends SvgIconProps {
    fill?: string;
}

export const QuoteIcon: React.FC<QuoteIconProps> = ({ fill = 'currentColor', ...props }) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <title>quote_right_fill</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fillRule="nonzero">
                    <path
                        d="M16.5,6 C18.4137,6 19.9686,7.5358 19.9995,9.44208 C20.0897,10.3071 20.0766,11.5831 19.492,13.0563 C18.8945,14.5618 17.7276,16.2042 15.6,17.7999 C15.1582,18.1313 14.5314,18.0418 14.2,17.5999 C13.8686,17.1581 13.9582,16.5313 14.4,16.1999 C15.964,15.027 16.8609,13.8865 17.3729,12.8903 C17.0938,12.9619 16.8014,13 16.5,13 C14.567,13 13,11.433 13,9.5 C13,7.567 14.567,6 16.5,6 Z M7.5,6 C9.41366,6 10.9686,7.5358 10.9995,9.44209 C11.0897,10.3071 11.0766,11.5831 10.492,13.0563 C9.89452,14.5618 8.72758,16.2042 6.59999,17.7999 C6.15816,18.1313 5.53136,18.0418 5.19999,17.5999 C4.86861,17.1581 4.95815,16.5313 5.39998,16.1999 C6.96395,15.027 7.86093,13.8865 8.37288,12.8903 C8.09385,12.9619 7.80137,13 7.5,13 C5.567,13 4,11.433 4,9.5 C4,7.567 5.567,6 7.5,6 Z"
                        fill={fill} // Dynamic fill color
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
